module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "background-loader modal"
  }, [_c('div', {
    staticClass: "preloader",
    attrs: {
      "aria-busy": "true",
      "aria-label": "Carregando...",
      "role": "progressbar"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-770bb938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/modal-loader/components/modal-loader.vue
// module id = 805
// module chunks = 1